import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './main.routes';

export class MainController {
  constructor($http, $scope, $state, authService) {
    $scope.$state = $state;
    $scope.authService = authService;
    $scope.$state = $state;
  }
}

MainController.$inject = ['$http', '$scope', '$state', 'authService'];

export default angular.module('syncplicityLoginApp.main', [uiRouter])
  .config(routing)
  .component('main', {
    template: require('./main.html'),
    controller: MainController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.js